angular.module('app.filters').filter('underscoreToSpace', function($filter) {
    return function(input) {
        return input.replace(/_/g,' ');
    };
});


// WEBPACK FOOTER //
// ./filters/underscore_to_space.js